import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  private readonly lockApp$ = new BehaviorSubject<boolean>(false);
  private readonly lockContent$ = new BehaviorSubject<boolean>(false);
  private readonly openSideNavigation$ = new Subject<void>();

  public get lockAppStream(): Observable<boolean> {
    return this.lockApp$.asObservable();
  }

  public get lockContentStream(): Observable<boolean> {
    return this.lockContent$.asObservable();
  }

  public get sideNavToggleStream(): Observable<void> {
    return this.openSideNavigation$.asObservable();
  }

  public lockApp(): void {
    this.lockApp$.next(true);
  }

  public unlockApp(): void {
    this.lockApp$.next(false);
  }

  public lockContentApp(): void {
    this.lockContent$.next(true);
  }

  public unlockContentApp(): void {
    this.lockContent$.next(false);
  }

  public toggleSideNav(): void {
    this.openSideNavigation$.next();
  }
}
